<template>
  <v-autocomplete
    v-model="params[type]"
    @change="applyFilter"
    @keyup="setSearch"
    :label="label"
    :items="hosts"
    :no-data-text="$t('appointment.filters.noData')"
    :loading="isFilterLoading"
    :item-text="itemText"
    :multiple="multiple"
    :disabled="disabled"
    :hide-no-data="hideNoData"
    :placeholder="placeholder"
    :persistent-placeholder="false"
    autocomplete="one-time-code"
    return-object
    clearable
    outlined
    small
    dense
  />
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex'
import store from '@/store'

export default {
  name: 'FilterAutocomplete',

  props: {
    fetchData: {
      type: Function,
      required: true,
    },

    label: {
      type: String,
      default: 'Filtro',
    },

    type: {
      type: String,
      required: true,
    },

    value: {
      type: String,
      default: 'value',
    },

    itemText: {
      default: 'name'
    },

    disabled: {
      required: false,
      default: false,
    },

    multiple: {
      type: Boolean,
      default: false,
      required: false
    },

    hideNoData: {
      type: Boolean,
      default: false,
    },

    placeholder: {
      type: String,
      default: '',
    }
  },

  methods: {
    ...mapMutations(['setFilters', 'setCurrentPage', 'setSearchTextHosts']),
    ...mapActions(['fetchHostsBySearchText']),

    async setSearch({ target }) {
        this.isFilterLoading = true

        if (this.params[this.type]) {
          for (var item in this.params[this.type]) {
            target.value.replace(item.name, "")
          }
        }

        await this.fetchHostsBySearchText(target.value)
          .then(() => {
            this.hosts = this.searchTextHosts
            this.addMissingHosts()
          })
          .finally(() => {
            this.isFilterLoading = false
          })
    },
    clearFilter() {
        this.isFilterLoading = false
        this.setSearchTextHosts([])
    },
    addMissingHosts() {
      if (this.params[this.type]) {
        this.params[this.type].forEach(selectedHost => {
           if (this.hosts.filter(host => host.id == selectedHost.id).length <= 0) {
              this.hosts.push(selectedHost)
            }
        })
      }
    },
    applyFilter() {
      var mappedParams = {}
      mappedParams[this.type] = this.params[this.type].map(selectedHosts => selectedHosts[this.value])
      Promise.resolve(
        this.setFilters({ ...store.getters.filters, ...mappedParams })
      )
        .then(() => this.setCurrentPage(1))
        .then(() => this.fetchData())
    },
  },

  computed: {
    ...mapGetters(['searchTextHosts']),
  },
  data() {
    return {
      params: {},
      hosts: [],
      isFilterLoading: false,
    }
  },
}
</script>
